<template>
    <div class="text-center">
        <v-menu
            bottom
            left
            min-width="550"
            offset-y
            origin="top right"
            v-model="savedutyplanmenu"
            :close-on-content-click="false"
            transition="scale-transition"
            :disabled="menueDisabled === true">

            <template v-slot:activator="{ attrs, on }">
                <v-btn raised elevation="1" class="mt-1" min-width="0" text v-bind="attrs" v-on="on">
                    <v-icon>mdi-stack-exchange</v-icon>
                </v-btn>
            </template>

            <v-card style="background-color: #fff;">
                <v-card-title class="grey headline" style="color: white; font-size: 15px; font-weight: 500;">
                    <p class="pl-7 mb-5 mt-5">
                        Save Duty Plan Changes
                    </p>
                </v-card-title>


                <all-employees-list v-model="employees" v-if="savedutyplanmenu" />

                <v-divider></v-divider>

                <!-- >>> Action Buttons -->
                <v-card-actions style="margin-top: 20px; padding-bottom:10px; background-color: #fff;">
                    <v-spacer></v-spacer>
                    <v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="savedutyplanmenu = false">Cancel</v-btn>
                    <v-btn style="width:120px" depressed elevation="1" color="primary" @click="onClick_SaveDutyPlanChanges">Save</v-btn>
                </v-card-actions>
                <!-- <<< Action Buttons -->
            </v-card>
        </v-menu>
    </div>
</template>

<script>
    import AllEmployeesList from '../AllEmployeesList.vue';

    import { mapActions } from 'vuex';


    export default {
        name: 'savedutyplanchangesmenue',

        /* >>> *************************************************************** / /* Components */
        components: {

            AllEmployeesList,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            savedutyplanmenu: false,
            menueDisabled: false,
            // >>> ------------------------------
            employees: [],

        }), // eo function  data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {
        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
		created: function () {

            let me = this;


            me.$toc('>>> views/shared/components/core/SaveDutyPlanChangesMenue.vue >>> created');
            // >>> ----------------------------------------
            // eventBus.$on('onallemployeesloaded', this.onLoad_AllEmployees);

		}, // eof created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/shared/components/core/SaveDutyPlanChangesMenue.vue >>> beforeDestroy');

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_update_DutyPlanChanges',
            ]),


            /******************************************************************* 'Listeners - Emit'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onLoad_AllEmployees()
            *
            * Desc: Wait until list is loaded. Then enable Button.
            * Note:
            *
            */
            onLoad_AllEmployees: function() {

                let me = this;


                me.$toc('>>> views/shared/components/core/SaveDutyPlanChangesMenue.vue >>> onLoad_AllEmployees');
                this.menueDisabled = false;

            }, // eo function onLoad_AllEmployees()




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_SaveDutyPlanChanges()
            *
            * Desc:
            * Note:
            *
            */
            onClick_SaveDutyPlanChanges: function() {

                let me = this,
                    params = {};


                me.$toc('>>> views/shared/components/core/SaveDutyPlanChangesMenue.vue >>> onClick_SaveDutyPlanChanges');
                // >>> --------------------------------------------------------- // go go go
                this.savedutyplanmenu = false; // close

                params = {
                    'idResources': this.employees
                };


                this.actn_update_DutyPlanChanges(params);

            }, // eo function onClick_SaveDutyPlanChanges

        } // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-card {
        margin-top: 0px;
        margin-bottom: 0px;
    }
</style>

<style>
    .v-card__subtitle, .v-card__text, .v-card__title  {
        padding: 0px !important;
    }

    .v-card__title {
        font-size: 18px;
    }
</style>







